import { FC, PropsWithChildren, useRef } from "react";
import filterRoutes, { getDomain, withRouteDomains, withRoutesRoles } from "./filter";

// import { ReactLocationDevtools } from 'react-location-devtools';
import { Router } from "react-location";
import _ from "lodash";
import location from "./location";
// import { useReactiveVar } from "@apollo/client";
import routes from "./routes";

// import { currentConfigVar } from "_graphql/cache/config";
// import { currentUserVar } from "_graphql/cache/auth";

const _routes = _.chain(routes).thru(withRoutesRoles)
    .thru(withRouteDomains)
    .value();

const RoutesProvider: FC<PropsWithChildren> = ({ children }) => {
    // const currentTheme = useReactiveVar(currentConfigVar);
    // const currentUser = useReactiveVar(currentUserVar);
    return (
        <div className={getDomain() === "KEK" ? "" : "dark"}>
            <Router
                location={location}
                routes={_routes}
                filterRoutes={filterRoutes()}>
                {/* <ReactLocationDevtools initialIsOpen={false} /> */}
                {children}
            </Router>
        </div>
    );
};

export default RoutesProvider;
